/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".trigger-info-list[_ngcontent-%COMP%]{font-size:13px;padding:5px}.trigger-info-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{margin-left:10px;padding:6px 0}.trigger-info-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{font-weight:700;margin-right:4px}"];
export { styles as styles };
